import { useContext, useMemo } from 'react'
import { AccountContext } from '@/contexts/account'
import { env } from '@/libs/env'

export const useGuestAppUrl = (state?: { hotelId: string; plugin: any }) => {
  const { account, plugins } = useContext<any>(AccountContext)

  const hotelId = useMemo(() => {
    return (account && account.hotel.id) || state?.hotelId
  }, [account])

  const guestAppUrl = useMemo(() => {
    return env('GUEST_APP_URL')
  }, [plugins])

  const homePageUrl = useMemo(() => {
    return `${guestAppUrl}?hotelId=${hotelId}`
  }, [guestAppUrl])

  const mypageUrl = (checkinId: string, checkinCode: string) => {
    return `${guestAppUrl}/mypage/checkin-history/${checkinId}?hotelId=${hotelId}&checkinCode=${checkinCode}`
  }

  return {
    guestAppUrl,
    homePageUrl,
    mypageUrl,
  }
}
